


import React from 'react';
import { Card } from 'antd';
import { motion } from 'framer-motion';
import './Blog.css'; // Import CSS for styling
import constructionImage from '../images/underconstruction.avif'; // Image file for the construction theme

const BooksAuthors = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="blog-container"
    >
      <Card title="BooksAuthors (Under Construction)" className="blog-card">
        <div className="under-construction-message">
          <p>This page is under construction. Stay tuned for updates!</p>
        </div>
        <div className="construction-image">
          <img src={constructionImage} alt="Under Construction" />
        </div>
      </Card>
    </motion.div>
  );
};


export default BooksAuthors;